export default class Burger extends HTMLElement {
  constructor() {
    super();

    this.burger = this.querySelector('.js-burger');
    this.menu = document.getElementById(this.burger.dataset.menuId);

    this.burger.addEventListener('click', (e) => this.showMenu(e));

    document.addEventListener('dialog:hide', (e) => this.hideMenu(e));
  }

  /** @param {boolean} expanded */
  set ariaExpanded(expanded) {
    this.burger.setAttribute('aria-expanded', expanded);
  }

  get ariaExpanded() {
    return JSON.parse(this.burger.getAttribute('aria-expanded'));
  }

  /** @param {Event} e */
  showMenu(e) {
    e.preventDefault();
    this.burger.ariaExpanded = true;
    this.burger.classList.add('--active');

    if (this.burger.ariaExpanded) {
      this.menu.setAttribute('aria-expanded', 'true');
    }
  }

  /**
   * @description Reset burger button when menu is closed
   * @param {Event} e
   */
  hideMenu(e) {
    if (e.detail.dialogId == 'modal-menu') {
      this.burger.ariaExpanded = false;
      this.burger.classList.remove('--active');
      this.burger.focus();
    }
  }
}

customElements.get('f-burger') || customElements.define('f-burger', Burger);
